export default "__VITE_ASSET__C27boaCP__"